import { render, staticRenderFns } from "./OliverSalesDashboard.vue?vue&type=template&id=32def086"
import script from "./OliverSalesDashboard.vue?vue&type=script&lang=js"
export * from "./OliverSalesDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports